export default __webpack_public_path__ + "static/media/background-video.84d83099.mp4";